// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1pqYs","footer":"ModalInfo_footer__3_-uJ"};